function useComboboxControlValue(data) {
  return data?.value;
}
export {
  useComboboxControlValue
};
//# sourceMappingURL=combobox.js.map